// extracted by mini-css-extract-plugin
module.exports = {"Invitation":"xEW_b1LNdXJFFnzn9FS1","OrganizationItem":"SZKy3fpGcDsUkwU_QifT","OrganizationItemAvatar":"h1sz8SKjKoqIlPMWXTY4","OrgRow":"FLapaZ7g4urigQhii65S"};